import React from "react";
import { connect } from "react-redux";
import { Spinner, Row } from "reactstrap";
import { handleResponse } from "../../../helpers/handleresponse";
import { history } from "../../../helpers/history";
import { getKey } from "../../../helpers/UrlHelper";

class NetsCardpayment extends React.Component {
  state = {
    test: false,
    showLoader: true,
    template: undefined,
    loaderMsg: "PrePaymentLoadMsg"
  };

  componentDidMount = (prevProps, prevState) => {
    const { match, location } = this.props;
    if (match && match.params && match.params.id) {
      let encodedCheckout = localStorage.getItem("__dco")
      let checkoutOptions = undefined;
      if(encodedCheckout){
        checkoutOptions = JSON.parse(Buffer.from(encodedCheckout, "base64").toString("utf16le"))
      }
      if (location.search && checkoutOptions && checkoutOptions.stateNo == match.params.id) {
        const params = new URLSearchParams(location.search);
        const paymentId = params.get(getKey('paymentId', params));
        let encodedTemplate = localStorage.getItem("__tmpl");
        if (encodedTemplate) {
          // let template = JSON.parse(atob(encodedTemplate));
          let template = JSON.parse(Buffer.from(encodedTemplate, "base64").toString("utf16le"))
          this.setState({ template });
          localStorage.removeItem("__tmpl");
        }
        checkoutOptions.paymentId = paymentId;
        this.addScript(checkoutOptions);
        localStorage.removeItem("__dco");
      } else {
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json" }
        };
        return fetch(`./api/nets/${match.params.id}`, requestOptions)
          .then(handleResponse)
          .then(response => {
            if (response.redirectUrl) {
              history.push(response.redirectUrl);
            }
            else {
              this.setState({ template: response.template }, () =>
                this.addScript(response.options)
              );
            }
          });
      }
    }
  };
  addScript = response => {
    if (!window.Dibs) {
      var s = document.createElement("script");
      s.src = response.testMode
        ? "https://test.checkout.dibspayment.eu/v1/checkout.js?v=1"
        : "https://checkout.dibspayment.eu/v1/checkout.js?v=1";
      document.head.appendChild(s);
      s.onload = e => this.initCheckout(response);
    } else {
      this.initCheckout(response);
    }
  };

  initCheckout = checkoutOptions => {
    checkoutOptions.containerId = "dibs-complete-checkout";
    checkoutOptions.theme = undefined;
    checkoutOptions.merchantHandlesConsumerData = true;
    let checkoutString = JSON.stringify(checkoutOptions);
    console.log("checkoutOpts", checkoutOptions)
    if (this.state.template) {
      let templateString = JSON.stringify(this.state.template);
      let encodedTemplate = Buffer.from(templateString, 'utf16le')
      // let encodedTemplate = btoa(templateString);
      localStorage.setItem("__tmpl", encodedTemplate.toString("base64"));
    }
    let encodedCheckout = Buffer.from(checkoutString, 'utf16le')
    // let encodedCheckout = btoa(checkoutString);
    localStorage.setItem("__dco", encodedCheckout.toString("base64"));
    var checkout = new window.Dibs.Checkout(checkoutOptions);
    //this is the event that the merchant should listen to redirect to the “payment-is-ok” page
    checkout.on("payment-completed", response => {
      this.setState({ showLoader: true, loaderMsg: 'PostPaymentLoadMsg' }, () => {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        };
        return fetch(
          `./api/nets/${this.props.match.params.id}?paymentId=${response.paymentId}`,
          requestOptions
        )
          .then(handleResponse)
          .then(response => {
            localStorage.removeItem("__tmpl");
            localStorage.removeItem("__dco");
            var redirectUrl = window.location.origin + (!window.location.href.includes("localhost") ? "/cms" : "") + response.redirectUrl;
            window.location.replace(redirectUrl);
          });
      });
    });
    setTimeout(() => this.setState({ showLoader: false }), 1500);
  };
  render = () => {
    const { template } = this.state;

    return (
      <React.Fragment>
        <style>
          {template ? template.css : null}
          {`#dibs-complete-checkout>iframe{
          min-height:unset;
        }`}
        </style>
        <div style={{ height: "100vh", overflowY: "hidden", position: "relative",display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "stretch" }}>
          {this.state.showLoader === true ? (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 4000,
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Spinner
                style={{
                  width: "3rem",
                  height: "3rem"
                }}
                color="info"
              />
            </div>
          ) : null}
          <div id="dibs-complete-checkout"
            style={{
              maxHeight: "100%",
              maxWidth:"100%",
              overflowY: "auto",
            }
            } ></div>
        </div>
      </React.Fragment>
    );
  };
}

function mapStateToProps(state) {
  return {
    globals: state.globals,
    alert: state.alert
  };
}
export default connect(mapStateToProps)(NetsCardpayment);


